/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

//covet pics gallery aspect ratio override
  // triggers when gallery is ready
document.addEventListener('galleryReady:covetPics', function(e) {
  // prepare CSS styles to inject
 const covetAspectRatio = document.createElement('style')
 covetAspectRatio.innerHTML = `
   .swiper-slide {
     aspect-ratio: 4/5;
     height:100%;
   }
 `
 // get Covet gallery elements where you want to inject CSS (for eg. covet-pics-widget, covet-pics-popup, covet-pics-upload)
 const covetGallerySlider = document.querySelector("covet-pics-widget");

 // now inject CSS code into shadow DOM
 covetGallerySlider.shadowRoot.appendChild(covetAspectRatio);
});


window.addEventListener("DOMContentLoaded", function() {
  if (window.location.pathname.indexOf('/products/') !== -1) {
    let productVarSelection = document.querySelector(".radio__buttons");
    let chosenOosVariantLoad = document.querySelector(".radio__button.sold-out input:checked");
    let excludeBisLoad = document.querySelector(".exclude_bis");
    if (chosenOosVariantLoad && !excludeBisLoad) {
      document.querySelector("#AddToCart--template--24414061724024__main").classList.add('hidden');
    }
    
    productVarSelection.addEventListener('change', function() {
      let soldOutButton = document.querySelector("#AddToCart--template--24414061724024__main");
      let variantOos = document.querySelector(".variant--soldout");
      let excludeBis = document.querySelector(".exclude_bis");
      if(soldOutButton.innerText.toLowerCase().includes("sold") && variantOos && !excludeBis){
        soldOutButton.classList.add('hidden');
      } else {
        soldOutButton.classList.remove('hidden');
      }
    });
  }
  }, false);
  
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();